import { render } from "./GameItems.vue?vue&type=template&id=8416aaae&scoped=true"
import script from "./GameItems.vue?vue&type=script&lang=js"
export * from "./GameItems.vue?vue&type=script&lang=js"

import "./GameItems.vue?vue&type=style&index=0&id=8416aaae&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8416aaae"]])

export default __exports__